import GoogleGeoCoding from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/GoogleGeoCoding'

export default () => {
  // memo
  const map = new Map()

  /**
   * @param {string} address
   * @return {[{ lat: string, lng: string } | undefined, error: Error | undefined]}
   */
  return async address => {
    if (address == null || address.length === 0)
      return [undefined, new Error(`Address is empty`)]
    if (map.has(address)) {
      return [map.get(address)]
    } else {
      try {
        const { results } = await GoogleGeoCoding.geoCoding(address)
        if (results.length) {
          const [result] = results
          const latLng = result ? result.geometry.location : null
          map.set(address, latLng)
          return [latLng]
        } else {
          return [undefined, new Error(`No results`)]
        }
      } catch (e) {
        return [undefined, e]
      }
    }
  }
}
